import { httpReq } from '@/utils/api.utils';

export const approveModelLegalTerms = async (modelIds: string[]) =>
  await httpReq<{ modelIds: string[] }, void>('/v1/workspaces/models/approve', { modelIds });
